import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import CarsForSale from "./pages/CarsForSale";
import CarDetail from "./pages/CarDetail";
import Motorcycles from "./pages/Motorcycles";
import Racing from "./pages/Racing";
import Services from "./pages/Services";
import History from "./pages/History";
import Sold from "./pages/Sold";
import Wanted from "./pages/Wanted";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import CookieBanner from "./components/CookieBanner";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import { Toaster } from "./components/ui/toaster";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const PublicLayout = ({ children }) => (
  <>
    <Header />
    <main className="flex-1">{children}</main>
    <Footer />
    <CookieBanner />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
          <Route path="/cars-for-sale" element={<PublicLayout><CarsForSale /></PublicLayout>} />
          <Route path="/motorcycles" element={<PublicLayout><Motorcycles /></PublicLayout>} />
          <Route path="/racing" element={<PublicLayout><Racing /></PublicLayout>} />
          <Route path="/services" element={<PublicLayout><Services /></PublicLayout>} />
          <Route path="/product/:slug" element={<PublicLayout><CarDetail /></PublicLayout>} />
          <Route path="/history" element={<PublicLayout><History /></PublicLayout>} />
          <Route path="/sold" element={<PublicLayout><Sold /></PublicLayout>} />
          <Route path="/car-sourcing" element={<PublicLayout><Wanted /></PublicLayout>} />
          <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
          <Route path="/privacy-policy" element={<PublicLayout><PrivacyPolicy /></PublicLayout>} />
          <Route path="/terms-conditions" element={<PublicLayout><TermsConditions /></PublicLayout>} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
